import { z } from "zod";

export const serverResponse = z.object({
  installationToken: z.string(),
});

export const errorResponse = z.object({
  code: z.string().or(z.number()),
});
